package at.theatervogelweide.admin.contract.club

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/** Verein (#106): every admin reads the club's texts, only superusers save them. */
@Rpc
interface ClubService {
    suspend fun load(): AdminResult<Club>

    /** Answers with `forbidden` unless the signed-in account is a superuser, `conflict` for a stale [club] version. */
    suspend fun save(club: VersionedId, draft: ClubDraft): AdminResult<Club>
}
